import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { IParameterApi } from './base/parameterApi';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';
import { ParameterTypesResponse } from '../models/response/parameterTypesResponse';
import { ParameterFilterRequest } from '../models/request/parameterFilterRequest';

const baseRoute: string = 'Parameter';

export class ParameterApi extends IParameterApi {
  getDomain(
    request: ParameterFilterRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getParametersByType(
    request: number
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/getparametersbytype`, {
      params: { parameterTypeEnum: request }
    });
  }

  saveParameter(request: any): Promise<AxiosResponse<Result<any>>> {
    return api.post(`${baseRoute}`, request, {
      timeout: TimeoutRequestConfigurationEnum.ThreeMinutesInMilliseconds
    });
  }

  getParameters(
    request: ParameterFilterRequest
  ): Promise<AxiosResponse<Result<ParameterTypesResponse[]>>> {
    return api.get(`${baseRoute}/getparameterbysystem`, {
      params: request
    });
  }
}
